/* eslint-disable react/require-default-props,react/destructuring-assignment,react/sort-comp,react/prop-types,jsx-control-statements/jsx-use-if-tag */
import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { autobind } from 'core-decorators';
import { connect } from 'react-redux';
import format from 'date-fns-old/format';
import get from 'lodash/get';
import head from 'lodash/head';
import isEmpty from 'lodash/isEmpty';
import { saveAs } from 'file-saver';
import { actions as exportToPDFActions } from '../../../redux/surveys/exportToPDF';
import { actions as reqFormResult } from '../../../redux/surveys/reqFormResult';
import {
  targetUserIdSelector,
  targetUserSelector,
} from '../../../redux/context/selectors';
import {
  formResultSelector,
  loadingFormResultSelector,
} from '../../../redux/surveys/selectors';
import { activeContextChannelSelector } from '../../../redux/chatConnection/selectors';
import ClickableElement from '../../ClickableElement/index';
import ExpandableListItem from '../../ExpandableListItem/index';
import Review from '../../Survey/Review';
import ExportBtn from './ExportBtn';
import EmptyState from './EmptyState';
import { ACTIONS } from '../../../constants/strings';
import createSurveyPdfName from '../../../utils/createSurveyPdfName';
import { getRespondentData } from '../../Survey/helpers/getRespondentData';
import { convertPreVisitFormData } from '../../Surveys/utils/preVisitForm';
import { getSurveyHeaderSubtitle } from '../../../utils/survey/getSpecification';
import ProgramPopupContent from './ProgramPopupContent';
import { SURVEY_TYPES } from '../../Healthboard/Components/VisitSurveyListView/constants';

/*
 * TODO: move answered surveys prop validation into constants
 * as it's common validation for several components
 */

const mapStateToProps = (state, { targetUserId, activeChannelId }) => ({
  targetUserId: targetUserId || targetUserIdSelector(state),
  targetUser: targetUserSelector(state),
  surveys: get(state, 'surveys.answered.list'),
  surveysLoading: get(state, 'surveys.answered.sending'),
  export: get(state, 'surveys.pdfExport'),
  targetForm: formResultSelector(state),
  targetFormLoading: loadingFormResultSelector(state),
  activeChannelId: activeChannelId || activeContextChannelSelector(state),
});

const mapDispatchToProps = {
  exportToPDF: exportToPDFActions.send,
  fetchAnsweredSurvey: reqFormResult.send,
  clearExportToPDF: exportToPDFActions.clear,
};

@injectIntl
@connect(
  mapStateToProps,
  mapDispatchToProps,
)
export default class ProgramPopup extends PureComponent {
  static contextTypes = {
    store: PropTypes.object,
  };

  static propTypes = {
    date: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    program: PropTypes.object,
    surveys: PropTypes.array,
    openedSurveyId: PropTypes.number,
    openedAssignmentId: PropTypes.number,
    forceFetch: PropTypes.bool,
    targetUserId: PropTypes.number,
    surveysLoading: PropTypes.bool,
    intl: PropTypes.shape({
      formatMessage: PropTypes.func,
    }),
    targetUser: PropTypes.shape({
      displayableName: PropTypes.string,
    }),
    pdfExportable: PropTypes.bool,
    exportToPDF: PropTypes.func,
    clearExportToPDF: PropTypes.func,
    export: PropTypes.shape({
      sending: PropTypes.bool,
      succeed: PropTypes.bool,
      blob: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    }),
    children: PropTypes.any,
    targetForm: PropTypes.object,
    targetFormLoading: PropTypes.bool,
    activeChannelId: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    isButton: PropTypes.bool,
  };

  static childContextTypes = {
    intl: PropTypes.object,
  };

  state = {
    exportInProgress: false,
    exportName: null,
    isOpened: false,
  };

  getChildContext() {
    return {
      intl: this.props.intl,
    };
  }

  node = null;

  get isProviderPostVisitForm() {
    const { targetForm } = this.props;
    return targetForm.surveyType === SURVEY_TYPES.PROVIDER_POST_VISIT;
  }

  componentWillReceiveProps(nextProps) {
    const { openedSurveyId } = nextProps;

    const { clearExportToPDF } = this.props;

    if (openedSurveyId) {
      setTimeout(() => this.scrollToItem(openedSurveyId), 0);
    }

    if (this.state.exportInProgress) {
      const pdfLoaded =
        this.props.export.sending &&
        !nextProps.export.sending &&
        nextProps.export.succeed;

      if (pdfLoaded) {
        const { blob } = nextProps.export;

        blob && saveAs(blob, this.state.exportName); // eslint-disable-line no-unused-expressions
        this.setState({ exportInProgress: false });
        clearExportToPDF();
      }
    }
  }

  @autobind
  handleOpenPopup(e) {
    const {
      forceFetch,
      targetUserId,
      openedAssignmentId,
      activeChannelId,
    } = this.props;

    e.preventDefault();
    this.setState({ isOpened: true });

    if (forceFetch) {
      this.props.fetchAnsweredSurvey({
        userId: targetUserId,
        assignmentId: openedAssignmentId,
        channelId: activeChannelId,
      });
    }
  }

  @autobind
  handleClosePopup() {
    this.setState({ isOpened: false });
  }

  scrollToItem(id) {
    const targetElement =
      this.node && this.node.querySelector(`[data-id="${id}"]`);

    if (targetElement) {
      targetElement.scrollIntoView();
    }
  }

  getRespondentHeading = assignments => {
    const {
      intl: { formatMessage },
    } = this.props;
    const assigment = head(assignments);
    const text = getRespondentData(assigment, true);

    return (
      <span>
        {formatMessage(ACTIONS.survey.answeredBy)} {text}
      </span>
    );
  };

  @autobind
  getSurveyPopup() {
    const {
      date,
      exportToPDF,
      openedAssignmentId,
      openedSurveyId,
      pdfExportable,
      program,
      targetUserId,
      targetForm,
      intl: { formatMessage },
    } = this.props;

    if (!targetForm && !program)
      return <EmptyState centered={!!openedSurveyId} />;

    if (isEmpty(targetForm) && !program)
      return <EmptyState centered={!!openedSurveyId} />;

    const {
      frequency,
      id,
      name,
      questions,
      assignments,
      scorecard,
      description,
      surveyType,
    } = targetForm;

    const assigment = head(assignments);
    const { userAppointment, assignmentMethod, assigner } = assigment || {};

    const list = convertPreVisitFormData(formatMessage, userAppointment);
    let subtitle = getSurveyHeaderSubtitle(
      surveyType,
      frequency,
      formatMessage,
      assignmentMethod,
      assigner,
    );

    let surveyTitle = program
      ? `${program.name} program: ${name}`
      : `program: ${name}`;

    if (this.isProviderPostVisitForm) {
      subtitle = formatMessage({ id: 'appointment.postVisitForm' });
      surveyTitle = name;
    }

    let note;
    const reviewOptions = {
      questions,
      assignments,
      date,
      scorecard,
      assignmentId: openedAssignmentId,
      isProviderPostVisitForm: this.isProviderPostVisitForm,
    };

    if (pdfExportable && !this.isProviderPostVisitForm) {
      const API_FORMAT = 'YYYY-MM-DD';
      const action = () => {
        const params = {
          userId: targetUserId,
          assignmentId: openedAssignmentId,
          date: format(date, API_FORMAT),
        };

        const userName = get(this.props.targetUser, 'displayableName');

        this.setState(
          {
            exportInProgress: true,
            exportName: createSurveyPdfName(name, userName, date),
          },
          () => exportToPDF(params),
        );
      };
      note = <ExportBtn onClick={action} />;
    }

    return (
      <Fragment>
        <p className="mb3 o-70 f-12">
          {this.getRespondentHeading(assignments)}
        </p>
        <ExpandableListItem
          data-id={id}
          key={id}
          opened
          header={{
            icon: 'surveys',
            title: surveyTitle,
            subtitle,
            note,
            description,
            list,
          }}
          locked={!!date}
        >
          <Review {...reviewOptions} />
        </ExpandableListItem>
      </Fragment>
    );
  }

  render() {
    const {
      date,
      program,
      surveysLoading,
      targetUser: { displayableName },
      intl,
      isProgram,
      targetFormLoading,
      isButton,
    } = this.props;

    const { formatMessage } = intl;
    const titleRef = date ? 'followup' : 'title';
    const titleWithUser = formatMessage(ACTIONS.program[titleRef], {
      user: displayableName,
    });

    return (
      // If the child is a button and its parent is a div with role ="button"
      // it causes accessibility problems that reason why I add condition isButton
      <div>
        {isProgram || isButton ? (
          <div
            className="di"
            onClick={isButton ? this.handleOpenPopup : () => {}}
          >
            {this.props.children}
          </div>
        ) : (
          <ClickableElement
            onClick={this.handleOpenPopup}
            className="di"
            hoverable
            ariaLabel="review"
          >
            {this.props.children}
          </ClickableElement>
        )}
        <If condition={this.state.isOpened}>
          <ProgramPopupContent
            title={titleWithUser}
            onClose={this.handleClosePopup}
            date={date}
            surveyPopup={this.getSurveyPopup()}
            surveysLoading={surveysLoading}
            targetFormLoading={targetFormLoading}
            program={program}
            contextStore={this.context.store}
            children={
              <div ref={node => (this.node = node)}>
                {this.getSurveyPopup()}
              </div>
            }
          />
        </If>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/common/ProgramPopup/index.jsx